import { loadable } from 'utils';

export const Allocation = loadable(() => import('./Catalog/AllocationStep'), {});
export const Basic = loadable(() => import('./Basic'), {});
export const Catalog = loadable(() => import('./Catalog'), {});
export const CreateWizard = loadable(() => import('./CreateWizard'), {});
export const ImportWizard = loadable(() => import('./ImportWizard'), {});
export const Form = loadable(() => import('./Form'), {});
export const Kit = loadable(() => import('./Kit'), {});
export const Media = loadable(() => import('./Media'), {});
export const Stock = loadable(() => import('./Stock'), {});
export const SuggestionWorkflow = loadable(() => import('./SuggestionWorkflow'), {});
